import { UserInfo } from "../../apps/reader/framework/api/features/user/types";
import { hash } from "../utils/string";
import { useLocalStorageValue } from "../ui/useLocalStorageValue";

export enum FractionStorageKey {
  COOKIE_CATEGORIES = "cookie-categories",
  EXPIRING_SOON_TOAST = "expiring-soon-book-toast-",
}

/**
 * Option 2: Stored via user-specific key in local storage
 * @see useFractionPersistValue
 */
export default function useFractionStorageValue<T = any>(
  userInfo: UserInfo,
  key: FractionStorageKey,
  keySuffix?: string
) {
  const persistKey = `_${hash(userInfo.email)}_fraction_data`;
  const { value, updateValue } = useLocalStorageValue(persistKey);
  const dataKey = keySuffix ? `${key}${keySuffix}` : key;

  function updateStorageValue(newValue: T) {
    updateValue({ ...value, [dataKey]: newValue });
  }

  return {
    value: value[dataKey] as T,
    updateValue: updateStorageValue,
  };
}
